<template>
  <div class="row-actions">
    <ul class="bqY" role="toolbar">
      <slot :item="item" name="default" />
    </ul>
  </div>
</template>

<script>
export default {
  props: ['item']
}
</script>

<style scoped>
  .row-actions {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    flex: 0 0 auto;
    position: absolute;
    right: 0px;
    top: 0px;

    height: 100%;
    justify-content: center;
    align-items: center;
  }
  .bqY {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    margin: 4px 6px;
    padding: 0;
  }
  .bqX {
    height: 20px;
    opacity: .54;
    width: 20px;
    opacity: .54;
    align-items: center;
    border: none;
    display: inline-flex;
    justify-content: center;
    outline: none;
    position: relative;
    z-index: 0;
    cursor: pointer;
    list-style: none;
    margin: 0 10px;
   }
  .brq {
    background-image: url(https://www.gstatic.com/images/icons/material/system/1x/archive_black_20dp.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 20px;
  }
  .bru {
    background-image: url(https://www.gstatic.com/images/icons/material/system/1x/delete_black_20dp.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 20px;
  }
  .brr {
    background-image: url(https://www.gstatic.com/images/icons/material/system/1x/drafts_black_20dp.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 20px;
  }
  .brv {
    background-image: url(https://www.gstatic.com/images/icons/material/system/1x/watch_later_black_20dp.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 20px;
  }

  .bqX:not(.pW)::before {
    content: '';
    display: block;
    opacity: 0;
    position: absolute;
    transition-duration: .15s;
    transition-timing-function: cubic-bezier(0.4,0.0,0.2,1);
    z-index: -1;
    bottom: -10px;
    left: -10px;
    right: -10px;
    top: -10px;
    background: none;
    border-radius: 50%;
    box-sizing: border-box;
    transform: scale(0);
    transition-property: transform,opacity;
    bottom: -10px;
    left: -10px;
    right: -10px;
    top: -10px;
  }
  .bqX:not(.pW):hover::before {
    background-color: rgba(32,33,36,0.059);
    border: none;
    box-shadow: none;
    opacity: 1;
    transform: scale(1);
  }
  .bqX:not(.pW):hover, .bqX:not(.pW):focus, .bqX:not(.pW):active {
    opacity: 1;
  }

  .bqX:not(.pW):after {
    content: '';
    height: 200%;
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
  }
</style>



// WEBPACK FOOTER //
// src/components/meridian/RowActions.vue